import { type ReactNode } from 'react';

type Block = {
  node: ReactNode;
  type: string;
  height: number;
};

export type Group = {
  blocks: Block[];
  totalHeight: number;
};

const makeNewGroup = (block: Block): Group => {
  const { node, height, type } = block;
  return {
    blocks: [
      {
        node,
        height,
        type,
      },
    ],
    totalHeight: height,
  };
};

const addBlockToGroup = (group: Group, block: Block): Group => {
  const { blocks } = group;

  blocks.push(block);
  group.totalHeight += block.height;

  return group;
};

export const groupBlock = (blocks: Block[], maxHeight: number) => {
  return blocks.reduce<Group[]>((acc, block) => {
    if (block.type === 'question') {
      acc.push(makeNewGroup(block));
    } else {
      const lastGroup = acc.at(-1);
      if (!lastGroup) return acc;

      const { totalHeight } = lastGroup;
      if (totalHeight + block.height > maxHeight) {
        acc.push(makeNewGroup(block));
      } else {
        addBlockToGroup(lastGroup, block);
      }
    }

    return acc;
  }, []);
};
